module.exports = __webpack_public_path__ + "img/scene_15.f2dc48a5.jpg";